module.exports = __webpack_public_path__ + "static/vice_x_renaissance_vert-3dda5559947be752769ad9c17c9a2f79.svg";